// Thin ESM wrapper over the shared core (generated copies — see the banner in
// landingComponentsCore.js). Binds the generated runtime assets so the
// client-side preview matches published output exactly.
import core from './landingComponentsCore';
import { LANDING_RUNTIME_CSS, LANDING_RUNTIME_JS } from './runtimeAssets';

const ASSETS = { css: LANDING_RUNTIME_CSS, js: LANDING_RUNTIME_JS };

export const {
  LANDING_COMPONENT_ATTRIBUTE,
  LANDING_COMPONENT_TYPES,
  SHARED_KEY,
  COMPONENT_LABELS,
  COMPONENTS_WITH_CONSENTS,
  FIELD_NAMES,
  CONSENT_NAMES,
  GALLERY_ASPECT_RATIOS,
  GALLERY_IMAGE_FITS,
  GALLERY_RATIO_VALUE,
  adaptCropToRatio,
  MAX_GALLERY_IMAGES,
  createDefaultLandingComponents,
  normalizeLandingComponents,
  findLandingComponentMarkers,
  validateLandingComponentMarkers,
  resolveLanguage,
} = core;

export const transformLandingComponentMarkers = (args) =>
  core.transformLandingComponentMarkers({ ...args, assets: ASSETS });
